import { render } from "./AreaModal.vue?vue&type=template&id=11928465"
import script from "./AreaModal.vue?vue&type=script&lang=js"
export * from "./AreaModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__